import React from 'react';

const Loader = ({ button }) => (
  <div className={`loader${button ? ' button' : ''}`}>
    <i className='fas fa-spinner' />
  </div>
);

export default Loader;
